// In every file you need this!
import $ from 'jquery';
//attach jquery to dom
window.jQuery = $;
window.$ = $;

$(document).ready(function () {

  // Some times you get random p tags that create space
  $('p:empty').remove();

  // Scroll to postion show monkey heads
  $(window).scroll(function() {
    if ($(".trigger_money_heads")[0]) {
      var hT = $('.trigger_money_heads').offset().top,
        hH = $('.trigger_money_heads').outerHeight(),
        wH = $(window).height(),
        wS = $(this).scrollTop();
      console.log((hT-wH) , wS);
      if (wS > (hT+hH-wH)){
        $( ".world_monkeys" ).trigger( "click" );
        console.log("Trigger Clicked");
      }
    }
  });

  // Clicking on monkey heads
  $('.world_monkeys').on('click', function() {
    var $this = $(this),
      $index  = $this.index(),
      $img = $this.children('img'),
      $imgSrc = $img.attr('src'),
      $imgAlt = $img.attr('data-alt'),
      $imgExt = $imgAlt.split('.');
              
      if($imgExt[1] === 'gif') {
        $img.attr('src', $img.data('alt')).attr('data-alt', $imgSrc);
      } else {
        $img.attr('src', $imgAlt).attr('data-alt', $img.data('alt'));
      }
  });

  $('.video_btn').on('click', function() { 
    $('.video')[0].play(); 
  });

  if ($(window).width() < 992) {
    $(".news_letter_inner p").find('br').remove();
  }

  $(document).ready(function() {
    var acc = document.getElementsByClassName("accordion");
    var i;

    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function() {

        /* Toggle between adding and removing the "active" class,
        to highlight the button that controls the panel */
        this.classList.toggle("active");


        /* Toggle between hiding and showing the active panel */
        var panel = this.nextElementSibling;
        if (panel.style.display === "block") {
          panel.style.display = "none";
        } else {
          panel.style.display = "block";
        }
      });
    }
  });

  // Changes variation options to radio buttons
  $(document).on('change', '.variation-radios input', function() {
    $('select[name="'+$(this).attr('name')+'"]').val($(this).val()).trigger('change');
  });

  // Custom class toggling to style the variable product radio buttons used
  $('.donate_wrapper .woovr-variation-name').on('click', function() {
    $(".woovr-variation").removeClass("woovr-checked");
    $(this).closest(".woovr-variation").addClass("woovr-checked");
  });

  // Contact form toggle buttons
  $('.form_select_buttons>div').on('click', function() {
    $(".form_select_buttons>div").removeClass("active");
    $(".form_outer").removeClass("active");
    $("." + $(this).attr("data-attr")).addClass("active");
  });

  $('.login_open').on('click', function() {
    $(".login_form_show").toggleClass("active");
    $(".open_arrow_icon").toggleClass("active");
  });

   $('.coupon_open').on('click', function() {
    $(".coupon_form_show").toggleClass("active");
    $(".open_arrow_icon_coupon").toggleClass("active");
  });

  $('.billing_open').on('click', function() {
    $(".show_billing").toggleClass("active");
    $(".open_arrow_icon_billing").toggleClass("active");
  });

  $('.shipping_billing_open').on('click', function() {
    $(".shipping_billing_address_show").toggleClass("active");
    $(".open_shipping_billing_arrow").toggleClass("active");
  });

  $('.order_notes_open').on('click', function() {
    $(".show_order_notes").toggleClass("active");
    $(".order_notes_arrow_arrow").toggleClass("active"); 
  });

  // Supporters toggle buttons
  $('.supporters_select_buttons .supporter_btn').on('click', function() {
    $(".supporter_btn").removeClass("active"); 
    $(".supporter_group").removeClass("active");

    $(this).addClass("active");
    $(".supporters_groups ." + $(this).attr("data-attr")).addClass("active");
  });

  // Supporters popups
  $(".supporter_group .post_wrapper").on("click", function() {
    $(".supporter_popup").removeClass("active");
    $(this).next().addClass("active");
  });

  $(document).on("click", ".supporter_popup_inner .close", function() {
    $(this).closest(".supporter_popup").removeClass("active");
  });

});

var TxtType = function(el, toRotate, period) {
  this.toRotate = toRotate;
  this.el = el;
  this.loopNum = 0;
  this.period = parseInt(period, 10) || 2000;
  this.txt = '';
  this.tick();
  this.isDeleting = false;
};

TxtType.prototype.tick = function() {
  var i = this.loopNum % this.toRotate.length;
  var fullTxt = this.toRotate[i];

  if (this.isDeleting) {
  this.txt = fullTxt.substring(0, this.txt.length - 1);
  } else {
  this.txt = fullTxt.substring(0, this.txt.length + 1);
  }

  this.el.innerHTML = '<span class="wrap">'+this.txt+'</span>';

  var that = this;
  var delta = 200 - Math.random() * 100;

  if (this.isDeleting) { delta /= 2; }

  if (!this.isDeleting && this.txt === fullTxt) {
  delta = this.period;
  this.isDeleting = true;
  } else if (this.isDeleting && this.txt === '') {
  this.isDeleting = false;
  this.loopNum++;
  delta = 500;
  }

  setTimeout(function() {
  that.tick();
  }, delta); 
};

window.onload = function() {
  var elements = document.getElementsByClassName('typewrite');
  for (var i=0; i<elements.length; i++) {
      var toRotate = elements[i].getAttribute('data-type');
      var period = elements[i].getAttribute('data-period');
      if (toRotate) {
        new TxtType(elements[i], JSON.parse(toRotate), period);
      }
  }
  // INJECT CSS
  var css = document.createElement("style");
  css.type = "text/css";
  css.innerHTML = ".typewrite > .wrap { border-right: 0.08em solid #7F59B0}";
  document.body.appendChild(css);
};